import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "@mui/material";
import React from "react";
import Reorder from "../../HOME/HomePageComponents/Reorder";
import { useState, useEffect } from "react";

function FinalChoicesSummery({ data }) {
  let [rows, setRows] = useState([]);
  const [categories, setCategories] = useState([]);

  // function createData(name, ug, pg, research, fo, ps, preMast, other, total) {
  //   return {
  //     name,
  //     ug,
  //     pg,
  //     research,
  //     fo,
  //     ps,
  //     preMast,
  //     other,
  //     total
  //   };
  // }

  // useEffect(() => {
  //   if (Object.keys(data).length > 0) {
  //     const previousYearUg = data?.previousYearUg || 0;
  //     const currentYearUg = data?.currentYearUg || 0;
  //     const percentageChangeUg =
  //       ((currentYearUg - previousYearUg) / Math.abs(previousYearUg)) * 100;

  //     const pgPercentage =
  //       ((data?.currentYearPg - data?.previousYearPg) /
  //         Math.abs(data?.previousYearPg)) *
  //         (100).toFixed(2) ==
  //         "Infinity" || "NaN"
  //         ? data?.currentYearPg
  //         : ((data?.currentYearPg - data?.previousYearPg) /
  //             Math.abs(data?.previousYearPg)) *
  //             (100).toFixed(2) +
  //           "%";

  //     const foPercentage =
  //       ((data?.currentYearFo - data?.previousYearFo) /
  //         Math.abs(data?.previousYearFo)) *
  //         (100).toFixed(2) ==
  //         "Infinity" || "NaN"
  //         ? data?.currentYearFo
  //         : ((data?.currentYearFo - data?.previousYearFo) /
  //             Math.abs(data?.previousYearFo)) *
  //             (100).toFixed(2) +
  //           "%";

  //     const psPercentage =
  //       ((data?.currentYearPs - data?.previousYearPs) /
  //         Math.abs(data?.previousYearPs)) *
  //         (100).toFixed(2) ==
  //         "Infinity" || "NaN"
  //         ? data?.currentYearPs
  //         : ((data?.currentYearPs - data?.previousYearPs) /
  //             Math.abs(data?.previousYearPs)) *
  //             (100).toFixed(2) +
  //           "%";

  //     const preMasterPercentage =
  //       ((data?.currentYearPreMaster - data?.previousYearPreMaster) /
  //         Math.abs(data?.previousYearPreMaster)) *
  //         (100).toFixed(2) ==
  //         "Infinity" || "NaN"
  //         ? data?.currentYearPreMaster
  //         : ((data?.currentYearPreMaster - data?.previousYearPreMaster) /
  //             Math.abs(data?.previousYearPreMaster)) *
  //             (100).toFixed(2) +
  //           "%";

  //     const previousPercentage =
  //       ((data?.currentYearOther - data?.previousYearOther) /
  //         Math.abs(data?.previousYearOther)) *
  //         (100).toFixed(2) ==
  //         "Infinity" || "NaN"
  //         ? data?.currentYearOther
  //         : ((data?.currentYearOther - data?.previousYearOther) /
  //             Math.abs(data?.previousYearOther)) *
  //             (100).toFixed(2) +
  //           "%";

  //     const totalPercentage =
  //       percentageChangeUg.toFixed(2) == "Infinity" || "NaN"
  //         ? 0
  //         : percentageChangeUg.toFixed(2) +
  //             ((data?.currentYearPg - data?.previousYearPg) /
  //               Math.abs(data?.previousYearPg)) *
  //               (100).toFixed(2) ==
  //             "Infinity" || "NaN"
  //         ? data?.currentYearPg
  //         : ((data?.currentYearPg - data?.previousYearPg) /
  //             Math.abs(data?.previousYearPg)) *
  //             (100).toFixed(2) +
  //           foPercentage +
  //           psPercentage +
  //           preMasterPercentage;

  //     setRows([
  //       createData(
  //         `Current Year (${
  //           data?.currentYear ? data?.currentYear : new Date().getFullYear()
  //         })`,
  //         data?.currentYearUg,
  //         data?.currentYearPg,
  //         data?.currentYearFo,
  //         data?.currentYearPs,
  //         data?.currentYearPreMaster,
  //         data?.currentYearOther,
  //         data?.currentYearUg +
  //           data?.currentYearPg +
  //           data?.currentYearFo +
  //           data?.currentYearPs +
  //           data?.currentYearOther
  //       ),
  //       createData(
  //         `Prior Year (${
  //           data?.previousYear ? data?.previousYear : new Date().getFullYear - 1
  //         })`,
  //         data?.previousYearUg,
  //         data?.previousYearPg,
  //         data?.previousYearFo,
  //         data?.previousYearPs,
  //         data?.previousYearPreMaster,
  //         data?.previousYearOther,
  //         data?.previousYearPg +
  //           data?.previousYearFo +
  //           data?.previousYearPs +
  //           data?.previousYearPreMaster +
  //           data?.previousYearOther
  //       ),

  //       createData(
  //         "% INC/DEC",
  //         percentageChangeUg.toFixed(2) == "Infinity" || "NaN"
  //           ? data?.currentYearUg
  //           : percentageChangeUg.toFixed(2) + "%",
  //         pgPercentage,
  //         foPercentage,
  //         psPercentage,
  //         preMasterPercentage,
  //         previousPercentage,
  //         // total
  //         totalPercentage
  //       )
  //     ]);
  //   }
  // }, [data]);

  useEffect(() => {
    if (Object.keys(data).length > 0) {
      const currentKeys = Object.keys(data).filter(
        (key) => key.startsWith("currentYear") && key !== "currentYear"
      );
      const previousKeys = Object.keys(data).filter(
        (key) => key.startsWith("previousYear") && key !== "previousYear"
      );

      // Extract category names dynamically
      const extractedCategories = currentKeys.map((key) =>
        key.replace("currentYear", "")
      );
      setCategories(extractedCategories);

      const rowsData = extractedCategories.map((category) => {
        const current = data[`currentYear${category}`] || 0;
        const previous = data[`previousYear${category}`] || 0;
        const percentageChange = previous
          ? (((current - previous) / Math.abs(previous)) * 100).toFixed(2) + "%"
          : "N/A";

        return {
          category,
          current,
          previous,
          percentageChange
        };
      });

      setRows(rowsData);
    }
  }, [data]);

  return (
    <Box
      sx={{
        width: "100%",
        overflowX: "scroll",
        "&::-webkit-scrollbar": { display: "none" }
      }}
    >
      <Table
        sx={{
          minWidth: "1200px",
          "& .MuiTableCell-root": {
            borderBottom: "1px solid rgba(220, 223, 227, 0.50)"
          }
        }}
      >
        <TableHead
          sx={{
            background: "#F9F9FB",
            "& th": {
              textTransform: "uppercase",
              fontWeight: "600",
              fontFamily: "Inter",
              color: "#666E7D"
            }
          }}
        >
          <TableRow>
            <TableCell>Course Level</TableCell>
            <TableCell>Current Year - {data?.currentYear}</TableCell>
            <TableCell>Previous Year - {data?.previousYear}</TableCell>
            <TableCell>% Change</TableCell>
          </TableRow>
        </TableHead>
        <TableBody
          sx={{
            background: "#fff",
            border: "1px solid rgba(220, 223, 227, 0.50)"
          }}
        >
          {rows.map((row, i) => (
            <TableRow key={i}>
              <TableCell>{row?.category}</TableCell>
              <TableCell>{row?.current}</TableCell>
              <TableCell>{row?.previous}</TableCell>
              <TableCell>{row?.percentageChange}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
}

export default FinalChoicesSummery;
